export const EXPAND_ALL_SECTIONS_CHECKBOX_CONFIGURATION = {
  name: 'skipExpanded',
  title: 'Zugeklappte Bereiche'
};

export const EXPAND_ALL_SUB_DEPOTS_CHECKBOX_CONFIGURATION = {
  name: 'skipSubDepotExpanded',
  title: 'Zugeklappte Unternummern'
};